<button class="item" (click)="open()">
    <fa-icon class="item-icon" [icon]="icon()"></fa-icon>
    <span class="item-text">{{displayName}}</span>
</button>